<template>
<el-tabs v-model="activeName">
<!--  <el-tab-pane label="资料管理" name="CaseDocumentsManager">-->
<!--    <CaseDocumentsManager-->
<!--      v-if="activeName==='CaseDocumentsManager'"-->
<!--      case-type="case"-->
<!--    />-->
<!--  </el-tab-pane>-->
  <el-tab-pane label="案件管理" name="LegalHouseLawCase">
    <LegalCaseList
      v-if="activeName==='LegalHouseLawCase'"
    />
  </el-tab-pane>
  <el-tab-pane label="法院管理" name="court">
    <CourtList v-if="activeName==='court'" />
  </el-tab-pane>
</el-tabs>
</template>

<script>
import CourtList from "./court/CourtList";
import LegalCaseList from '../law_case/case_list.vue';
import CaseDocumentsManager from '../CaseDocumentsManager.vue';

export default {
  name: "LitigationCaseLayout",
  components: {CourtList, LegalCaseList, CaseDocumentsManager},
  data() {
    return {
      activeName: 'LegalHouseLawCase'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/litigation/LitigationCaseLayout.vue